let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hdJVO")).then(() => parcelRequire('dHQ2Q'));